import React, { useState, useEffect } from 'react';
import moment from 'moment';
// import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ExportToExcel from '../../components/ExportToExcel.jsx'
import {
  Grid,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  CircularProgress,
  IconButton,
  FormLabel,
  AppBar,
  Tabs,
  Tab,
} from '@material-ui/core';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { withStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import SpeakerNotes from '@material-ui/icons/SpeakerNotes';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import LocationDisabledIcon from '@material-ui/icons/LocationDisabled';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import TabPanel from '../../components/TabPanel';
import Button from '../../components/Button';
import Avatar from '../../components/Avatar';
import ConsultNoteEditModal from '../../components/ConsultNoteEditModal';
import PatientSearchBar from '../../components/PatientSearchBar';
import TrackingTypeSearch from '../../components/TrackingTypeSearch';

import {
  fetchTrackingList,
  unTagPatientById,
  deleteTrackPatient,
  trackCount,
  createConsultNote,
  archiveConsultNote,
  unarchiveConsultNote,
  updateToggle,
} from '../../services/api';
import * as authApi from '../../services/api/auth';
import TrackingReports from './trackingRepots';
import PatientTrackingModal from '../ProviderAdminPatients/components/PatientTracking';
import RemovePatientTrackModal from '../../components/RemovePatientTrackModal';
import './style.css';
const ARCHIVED_BY_ID_TAB = 1;
const PAGE_LIMIT = 20;

function ProviderAdminTrackingList(props) {
  const { classes } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [consultNotes, setConsultNotes] = useState([]);
  const [tabPosition, setTabPosition] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [openConsultNoteEditModal, setOpenConsultNoteEditModal] = useState(
    false
  );
  const [noteUnderEdit, setNoteUnderEdit] = useState({});
  const [viewOnly, setViewOnly] = useState(true);
  const [providersSearchId, setProvidersSearchId] = useState(null);
  const [patientsSearchId, setPatientsSearchId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [datePicker, openDatePicker] = useState(false);
  const [openTrackingReports, setOpenTrackingReports] = useState(false);
  const [typeOfTrack, setTypeOfTrack] = useState(null);
  const [openConsultNotesModal, setOpenConsultNotesModal] = useState(false);
  const [patientTrackId, setPatientTrackId] = useState('');
  const [patientUnderEdit, setPatientUnderEdit] = useState({});
  const [
    openRemovePatientTrackModal,
    setOpenRemovePatientTrackModal,
  ] = useState(false);
  const [state, setState] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection',
    },
  ]);
  useEffect(() => {
    (async () => {
      const user = await authApi.fetchCurrentUser();
      setCurrentUser(user);
      await getTrackingList(user.id);
    })();
  }, []);
  let endDateValue = state[0].endDate;
  let startDateValue = state[0].startDate;
  useEffect(() => {
    (async () => {
      if (
        currentUser &&
        currentUser.id &&
        (startDateValue === null || startDateValue !== endDateValue)
      ) {
        await getTrackingList(currentUser.id);
      }
    })();
  }, [
    pageIndex,
    tabPosition,
    providersSearchId,
    typeOfTrack,
    endDateValue,
    patientsSearchId,
  ]);

  const getTrackingList = async id => {
    try {
      setIsLoading(true);
      let lastDate =
        state[0].endDate !== null
          ? moment(state[0].endDate).format('YYYY-MM-DD')
          : null;
      let firstDate =
        state[0].startDate !== null
          ? moment(state[0].startDate).format('YYYY-MM-DD')
          : null;
      //  let  start = moment(
      //     moment(startsOn).format('MM/DD/YYYY')
      //     + ' ' +
      //     moment(start).format('HH:mm')
      //   ).toISOString()
      //   let end = moment(
      //     moment(startsOn).format('MM/DD/YYYY')
      //     + ' ' +
      //     moment(end).format('HH:mm')
      //   ).toISOString()
      const notes = await fetchTrackingList(
        id,
        patientsSearchId,
        pageIndex * 20,
        PAGE_LIMIT,
        tabPosition === ARCHIVED_BY_ID_TAB,
        firstDate,
        lastDate,
        typeOfTrack
      );
      openDatePicker(false);
      setConsultNotes(notes);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to fetch notes, please try again.');
    }
  };

  const onDateRangeChange = dates => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const unTagPatient = async id => {
    try {
      setIsLoading(true);
      await unTagPatientById(id, true);
      await getTrackingList(currentUser.id);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to fetch notes, please try again.');
    }
  };

  const handleTabPositionChange = (event, newTabPosition) => {
    setPageIndex(0);
    setTabPosition(newTabPosition);
  };

  const name = { nam: currentUser && currentUser.name };
  const userId = String(name.nam);

  const onViewConsultNote = note => {
    setNoteUnderEdit(note);
    setOpenConsultNoteEditModal(true);
  };

  const onCloseModal = () => {
    setNoteUnderEdit({});
    setOpenConsultNoteEditModal(false);
    setOpenTrackingReports(false);
  };

  const onPageForward = () => {
    //this won't cover the case where the total num of consult notes % PAGE_LIMIT = 0. But it's a quick fix for now.
    if (consultNotes.length < PAGE_LIMIT) {
      enqueueSnackbar('You are on the last page');
    } else {
      setPageIndex(pageIndex + 1);
    }
  };

  const onPageBack = () => {
    if (pageIndex === 0) {
      enqueueSnackbar('You are on the first page');
    } else {
      setPageIndex(pageIndex - 1);
    }
  };

  const removeTrackPatient = id => {
    setOpenRemovePatientTrackModal(true);
    setPatientTrackId(id);
  };

  const onCloseRemovePatientModal = () => {
    setOpenRemovePatientTrackModal(false);
  };

  const onRemoveTrackSubmit = async () => {
    try {
      await deleteTrackPatient(patientTrackId);
      onCloseRemovePatientModal();
      await getTrackingList(currentUser.id);
      enqueueSnackbar('Removed from track!', {
        preventDuplicate: true,
        autoHideDuration: 3000,
      });
    } catch (err) {
      enqueueSnackbar('Unable to remove patient. Please try again.', {
        preventDuplicate: true,
        autoHideDuration: 3000,
      });
    }
  };

  const handlePatientToSearch = patient => {
    setPageIndex(0);
    setPatientsSearchId(patient && patient.id);
  };

  const handleTypeofTracking = data => {
    setPageIndex(0);
    setTypeOfTrack(data);
  };

  const onSendConsultNote = patient => {
    patient.name = patient.firstName + ' ' + patient.lastName;
    setPatientUnderEdit(patient);
    setOpenConsultNotesModal(true);
  };

  const sendConsultNote = async noteParams => {
    try {
      await createConsultNote(noteParams);
      onDialogClose();
      enqueueSnackbar('Successfully sent note!');
    } catch (err) {
      enqueueSnackbar('Unable to send note. Please try again.');
    }
  };

  const onDialogClose = () => {
    setPatientUnderEdit({});
    setOpenConsultNotesModal(false);
  };

  const changeDatePicker = () => {
    let stateData = [
      {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
      },
    ];
    setState(stateData);
  };

  const changeTonormal = () => {
    let stateData = [
      {
        startDate: null,
        endDate: null,
        key: 'selection',
      },
    ];
    openDatePicker(false); // To remove date picker.
    setPageIndex(0);
    setState(stateData);
    setPatientsSearchId(null);
    setTypeOfTrack(null);
    if (patientsSearchId && typeOfTrack) {
      getTrackingList(currentUser.id);
    }
  };

  return (
    <Grid container classes={{ container: classes.container }}>
      <Grid item xs={12} classes={{ item: classes.header }}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          className="paddingZero"
        >
          <Grid item lg={6} xl={6} md={6} xs={12} className="headingSize">
            <Typography variant="h2" className={classes.headerText}>
              Patient Tracking List
            </Typography>
          </Grid>

          <Grid
            item
            lg={6}
            xl={6}
            md={6}
            xs={12}
            classes={{ item: classes.actions }}
          >
            <ExportToExcel tableId="table-to-xls" filename="reports" />
            {/* <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="exportBtn btn submit-btn"
              table="table-to-xls"
              filename="reports"
              sheet="reports"
              buttonText="Export"
            /> */}
            <Button
              color="primary"
              variant="contained"
              onClick={() => setOpenTrackingReports(true)}
            >
              View Reports
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <AppBar
        position="static"
        color="default"
        classes={{ root: classes.appBar }}
      >
        <Tabs value={tabPosition} onChange={handleTabPositionChange}>
          <Tab label="Current Tracking List" />
          <Tab label="Tracking History" />
        </Tabs>
      </AppBar>

      <TabPanel className="paddingZero">
        <Grid container item xs={12}>
          <Grid item lg={6} xl={6} md={6} xs={12}>
            <PatientSearchBar
              clearable={true}
              id={currentUser ? currentUser.id : null}
              onSelect={handlePatientToSearch}
              placeholder="Filter by patient"
              label=""
            />
          </Grid>
          <Grid item lg={6} xl={6} md={6} xs={12}>
            <TrackingTypeSearch
              status={tabPosition === ARCHIVED_BY_ID_TAB}
              clearable={true}
              id={currentUser ? currentUser.id : null}
              onSelect={handleTypeofTracking}
              placeholder="Filter by type of tracking"
              label=""
            />
          </Grid>
          <div className="btnPad">
            <Button
              className="customdaterange-btn"
              color="primary"
              variant="contained"
              onClick={() => openDatePicker(!datePicker)}
            >
              SELECT START / END DATE
            </Button>
            {datePicker && (
              <div className={classes.customDatePicker}>
                {/* <DatePicker
                  onChange={onDateRangeChange}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  inline
                />  */}
                <div className={classes.datePickerUi}>
                  <DateRange
                    editableDateInputs={true}
                    onChange={item => setState([item.selection])}
                    moveRangeOnFirstSelection={false}
                    ranges={state}
                  />
                </div>
              </div>
            )}

            <Button
              className="customdaterange-btn"
              color="primary"
              variant="contained"
              onClick={() => changeDatePicker()}
            >
              patient tracking end for the day
            </Button>
            <Button
              className="customdaterange-btn"
              color="primary"
              variant="contained"
              onClick={() => changeTonormal()}
            >
              x
            </Button>
          </div>
          {isLoading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <Table id="table-to-xls" className="patientTrack">
                <TableHead>
                  <TableRow>
                    <TableCell>Patient</TableCell>
                    <TableCell>Type of Reason</TableCell>
                    <TableCell>Start Date</TableCell>
                    <TableCell>End Date</TableCell>
                    <TableCell>Message a Doc</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {consultNotes.length > 0 &&
                    consultNotes.map(note => (
                      <TableRow key={note.id}>
                        <TableCell width="300">
                          <Grid
                            container
                            alignItems="center"
                            className="profilePic"
                          >
                            <Avatar
                              providerId={note.patient.id}
                              customStyles={{
                                height: '35px',
                                width: '35px',
                              }}
                            />
                            <Grid item xs={6}>
                              {note.patient.firstName} &nbsp;{' '}
                              {note.patient.lastName}
                            </Grid>
                          </Grid>
                        </TableCell>
                        <TableCell width="250">{note.typeOfTrack}</TableCell>

                        <TableCell width="200">
                          {moment(note.startDate).format('MM/DD/YYYY hh:mma')}
                        </TableCell>
                        <TableCell width="200">
                          {moment(note.endDate).format('MM/DD/YYYY hh:mma')}
                        </TableCell>
                        <TableCell>
                          <IconButton
                            title="Doc to Doc Message"
                            onClick={() => onSendConsultNote(note.patient)}
                          >
                            <SpeakerNotes className={classes.drawerIcon} />
                          </IconButton>
                        </TableCell>
                        <TableCell>
                          <IconButton
                            title="view patient tracking details"
                            onClick={() => onViewConsultNote(note)}
                          >
                            <RemoveRedEyeIcon />
                          </IconButton>
                        </TableCell>
                        {tabPosition !== ARCHIVED_BY_ID_TAB && (
                          <TableCell>
                            <IconButton
                              title="untag patient"
                              onClick={() => unTagPatient(note.id)}
                            >
                              <LocationDisabledIcon />
                            </IconButton>
                          </TableCell>
                        )}
                        <TableCell>
                          <IconButton
                            title="Remove Track Patient"
                            onClick={() => removeTrackPatient(note.id)}
                          >
                            <DeleteForeverOutlinedIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              <div className={classes.pageTurners}>
                <IconButton disabled={pageIndex === 0}>
                  <ArrowBackIosIcon
                    style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
                    color="primary"
                    variant="contained"
                    onClick={onPageBack}
                  />
                </IconButton>
                <IconButton disabled={consultNotes.length < PAGE_LIMIT}>
                  <ArrowForwardIosIcon
                    style={{
                      opacity: consultNotes.length < PAGE_LIMIT ? '0.5' : '1.0',
                    }}
                    color="primary"
                    variant="contained"
                    onClick={onPageForward}
                  />
                </IconButton>
              </div>
            </>
          )}
        </Grid>
      </TabPanel>
      {openConsultNoteEditModal && (
        <PatientTrackingModal
          open={openConsultNoteEditModal}
          note={noteUnderEdit}
          closeDialog={onCloseModal}
          trackingEdit={true}
        />
      )}
      {openTrackingReports && (
        <TrackingReports
          open={openTrackingReports}
          closeDialog={onCloseModal}
        />
      )}
      {openConsultNotesModal && (
        <ConsultNoteEditModal
          patient={patientUnderEdit}
          open={openConsultNotesModal}
          save={sendConsultNote}
          onClose={onDialogClose}
        />
      )}
      {openRemovePatientTrackModal && (
        <RemovePatientTrackModal
          open={openRemovePatientTrackModal}
          onClose={onCloseRemovePatientModal}
          save={onRemoveTrackSubmit}
        />
      )}
    </Grid>
  );
}

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    padding: '3em',
  },
  appBar: {
    zIndex: 10,
  },
  header: {
    paddingBottom: '3em',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    lineHeight: '1.2em',
    color: '#1C1C1C',
  },
  actions: {
    textAlign: 'right',
  },
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  formControl: {
    marginTop: '20px',
    width: '100%',
  },
  customLabel: {
    fontSize: '20px',
    marginBottom: '15px',
    color: '#000 !important',
    display: 'block',
    marginTop: '20px',
  },
  customDatePicker: {
    position: 'relative',
  },
  datePickerUi: {
    position: 'absolute',
    zIndex: '11',
  },
});

export default withStyles(styles)(ProviderAdminTrackingList);
